import * as __SNOWPACK_ENV__ from '../../../_snowpack/env.js';

import './SearchControlPanel.svelte.css';
/* src/components/searchControl/SearchControlPanel.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	set_store_value,
	space,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';
import { getSearchOptions, getSearchResult } from '../../stores/libREST.js';
import { inputValues, setCurrentParams } from '../../stores/storeInputOptions.js';
import { searchResult, isLoading } from '../../stores/storeSearchResult.js';
import InputOptions from './InputOptions.svelte.js';
import InputKeywords from './InputKeywords.svelte.js';
import InputSort from './InputSort.svelte.js';
import InputChunk from './InputChunk.svelte.js';

function create_if_block(ctx) {
	let ul0;
	let li0;
	let inputoptions0;
	let t0;
	let li1;
	let inputoptions1;
	let t1;
	let li2;
	let inputoptions2;
	let t2;
	let li3;
	let inputoptions3;
	let t3;
	let ul1;
	let li4;
	let inputoptions4;
	let t4;
	let li5;
	let inputoptions5;
	let t5;
	let li6;
	let inputoptions6;
	let t6;
	let li7;
	let inputoptions7;
	let t7;
	let li8;
	let inputoptions8;
	let t8;
	let ul2;
	let li9;
	let inputkeywords;
	let t9;
	let ul3;
	let li10;
	let inputsort;
	let t10;
	let li11;
	let inputchunk;
	let t11;
	let li12;
	let current;

	inputoptions0 = new InputOptions({
			props: {
				id: "sb_at",
				name: "accessoryType_id",
				label: "アイテム：",
				options: /*inputOptions*/ ctx[0].type
			}
		});

	inputoptions1 = new InputOptions({
			props: {
				id: "sb_bc",
				name: "beadCode",
				label: "パワーストーン：",
				options: /*inputOptions*/ ctx[0].parts
			}
		});

	inputoptions2 = new InputOptions({
			props: {
				id: "sb_ac",
				name: "accessoryCode",
				label: "アクセサリデザイン：",
				options: /*inputOptions*/ ctx[0].design
			}
		});

	inputoptions3 = new InputOptions({
			props: {
				id: "sb_pr",
				name: "price_list",
				label: "価格帯：",
				options: /*inputOptions*/ ctx[0].price
			}
		});

	inputoptions4 = new InputOptions({
			props: {
				id: "sb_ft",
				name: "sb_ft",
				label: "運勢：",
				options: /*inputOptions*/ ctx[0].labels.FT
			}
		});

	inputoptions5 = new InputOptions({
			props: {
				id: "sb_bt",
				name: "sb_bt",
				label: "誕生石：",
				options: /*inputOptions*/ ctx[0].labels.BT
			}
		});

	inputoptions6 = new InputOptions({
			props: {
				id: "sb_cl",
				name: "sb_cl",
				label: "色：",
				options: /*inputOptions*/ ctx[0].labels.CL
			}
		});

	inputoptions7 = new InputOptions({
			props: {
				id: "sb_zo",
				name: "sb_zo",
				label: "干支：",
				options: /*inputOptions*/ ctx[0].labels.ZO
			}
		});

	inputoptions8 = new InputOptions({
			props: {
				id: "sb_hs",
				name: "sb_hs",
				label: "星座石：",
				options: /*inputOptions*/ ctx[0].labels.HS
			}
		});

	inputkeywords = new InputKeywords({});
	inputsort = new InputSort({});
	inputchunk = new InputChunk({});

	function select_block_type(ctx, dirty) {
		if (/*$isLoading*/ ctx[1]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			ul0 = element("ul");
			li0 = element("li");
			create_component(inputoptions0.$$.fragment);
			t0 = space();
			li1 = element("li");
			create_component(inputoptions1.$$.fragment);
			t1 = space();
			li2 = element("li");
			create_component(inputoptions2.$$.fragment);
			t2 = space();
			li3 = element("li");
			create_component(inputoptions3.$$.fragment);
			t3 = space();
			ul1 = element("ul");
			li4 = element("li");
			create_component(inputoptions4.$$.fragment);
			t4 = space();
			li5 = element("li");
			create_component(inputoptions5.$$.fragment);
			t5 = space();
			li6 = element("li");
			create_component(inputoptions6.$$.fragment);
			t6 = space();
			li7 = element("li");
			create_component(inputoptions7.$$.fragment);
			t7 = space();
			li8 = element("li");
			create_component(inputoptions8.$$.fragment);
			t8 = space();
			ul2 = element("ul");
			li9 = element("li");
			create_component(inputkeywords.$$.fragment);
			t9 = space();
			ul3 = element("ul");
			li10 = element("li");
			create_component(inputsort.$$.fragment);
			t10 = space();
			li11 = element("li");
			create_component(inputchunk.$$.fragment);
			t11 = space();
			li12 = element("li");
			if_block.c();
			attr(ul0, "class", "input_item");
			attr(ul1, "class", "input_label");
			attr(ul2, "class", "input_q");
			attr(li10, "class", "input_sort");
			attr(li11, "class", "input_chunk");
			attr(li12, "class", "input_send");
		},
		m(target, anchor) {
			insert(target, ul0, anchor);
			append(ul0, li0);
			mount_component(inputoptions0, li0, null);
			append(ul0, t0);
			append(ul0, li1);
			mount_component(inputoptions1, li1, null);
			append(ul0, t1);
			append(ul0, li2);
			mount_component(inputoptions2, li2, null);
			append(ul0, t2);
			append(ul0, li3);
			mount_component(inputoptions3, li3, null);
			insert(target, t3, anchor);
			insert(target, ul1, anchor);
			append(ul1, li4);
			mount_component(inputoptions4, li4, null);
			append(ul1, t4);
			append(ul1, li5);
			mount_component(inputoptions5, li5, null);
			append(ul1, t5);
			append(ul1, li6);
			mount_component(inputoptions6, li6, null);
			append(ul1, t6);
			append(ul1, li7);
			mount_component(inputoptions7, li7, null);
			append(ul1, t7);
			append(ul1, li8);
			mount_component(inputoptions8, li8, null);
			insert(target, t8, anchor);
			insert(target, ul2, anchor);
			append(ul2, li9);
			mount_component(inputkeywords, li9, null);
			insert(target, t9, anchor);
			insert(target, ul3, anchor);
			append(ul3, li10);
			mount_component(inputsort, li10, null);
			append(ul3, t10);
			append(ul3, li11);
			mount_component(inputchunk, li11, null);
			append(ul3, t11);
			append(ul3, li12);
			if_block.m(li12, null);
			current = true;
		},
		p(ctx, dirty) {
			const inputoptions0_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions0_changes.options = /*inputOptions*/ ctx[0].type;
			inputoptions0.$set(inputoptions0_changes);
			const inputoptions1_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions1_changes.options = /*inputOptions*/ ctx[0].parts;
			inputoptions1.$set(inputoptions1_changes);
			const inputoptions2_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions2_changes.options = /*inputOptions*/ ctx[0].design;
			inputoptions2.$set(inputoptions2_changes);
			const inputoptions3_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions3_changes.options = /*inputOptions*/ ctx[0].price;
			inputoptions3.$set(inputoptions3_changes);
			const inputoptions4_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions4_changes.options = /*inputOptions*/ ctx[0].labels.FT;
			inputoptions4.$set(inputoptions4_changes);
			const inputoptions5_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions5_changes.options = /*inputOptions*/ ctx[0].labels.BT;
			inputoptions5.$set(inputoptions5_changes);
			const inputoptions6_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions6_changes.options = /*inputOptions*/ ctx[0].labels.CL;
			inputoptions6.$set(inputoptions6_changes);
			const inputoptions7_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions7_changes.options = /*inputOptions*/ ctx[0].labels.ZO;
			inputoptions7.$set(inputoptions7_changes);
			const inputoptions8_changes = {};
			if (dirty & /*inputOptions*/ 1) inputoptions8_changes.options = /*inputOptions*/ ctx[0].labels.HS;
			inputoptions8.$set(inputoptions8_changes);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(li12, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(inputoptions0.$$.fragment, local);
			transition_in(inputoptions1.$$.fragment, local);
			transition_in(inputoptions2.$$.fragment, local);
			transition_in(inputoptions3.$$.fragment, local);
			transition_in(inputoptions4.$$.fragment, local);
			transition_in(inputoptions5.$$.fragment, local);
			transition_in(inputoptions6.$$.fragment, local);
			transition_in(inputoptions7.$$.fragment, local);
			transition_in(inputoptions8.$$.fragment, local);
			transition_in(inputkeywords.$$.fragment, local);
			transition_in(inputsort.$$.fragment, local);
			transition_in(inputchunk.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inputoptions0.$$.fragment, local);
			transition_out(inputoptions1.$$.fragment, local);
			transition_out(inputoptions2.$$.fragment, local);
			transition_out(inputoptions3.$$.fragment, local);
			transition_out(inputoptions4.$$.fragment, local);
			transition_out(inputoptions5.$$.fragment, local);
			transition_out(inputoptions6.$$.fragment, local);
			transition_out(inputoptions7.$$.fragment, local);
			transition_out(inputoptions8.$$.fragment, local);
			transition_out(inputkeywords.$$.fragment, local);
			transition_out(inputsort.$$.fragment, local);
			transition_out(inputchunk.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(ul0);
			destroy_component(inputoptions0);
			destroy_component(inputoptions1);
			destroy_component(inputoptions2);
			destroy_component(inputoptions3);
			if (detaching) detach(t3);
			if (detaching) detach(ul1);
			destroy_component(inputoptions4);
			destroy_component(inputoptions5);
			destroy_component(inputoptions6);
			destroy_component(inputoptions7);
			destroy_component(inputoptions8);
			if (detaching) detach(t8);
			if (detaching) detach(ul2);
			destroy_component(inputkeywords);
			if (detaching) detach(t9);
			if (detaching) detach(ul3);
			destroy_component(inputsort);
			destroy_component(inputchunk);
			if_block.d();
		}
	};
}

// (151:4) {:else}
function create_else_block(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "button");
			input.value = "検索";
		},
		m(target, anchor) {
			insert(target, input, anchor);

			if (!mounted) {
				dispose = listen(input, "click", /*sendOptions*/ ctx[2]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(input);
			mounted = false;
			dispose();
		}
	};
}

// (149:4) {#if $isLoading}
function create_if_block_1(ctx) {
	let input;

	return {
		c() {
			input = element("input");
			attr(input, "type", "button");
			input.value = "検索";
			input.disabled = true;
			attr(input, "class", "wait");
		},
		m(target, anchor) {
			insert(target, input, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(input);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current;
	let if_block = /*inputOptions*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "search-input-options");
			attr(div, "style", /*backgroundStyle*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*inputOptions*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*inputOptions*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div, null);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $isLoading;
	let $inputValues;
	let $searchResult;
	component_subscribe($$self, isLoading, $$value => $$invalidate(1, $isLoading = $$value));
	component_subscribe($$self, inputValues, $$value => $$invalidate(4, $inputValues = $$value));
	component_subscribe($$self, searchResult, $$value => $$invalidate(5, $searchResult = $$value));
	let inputOptions;

	onMount(async () => {
		set_store_value(isLoading, $isLoading = false, $isLoading);
		$$invalidate(0, inputOptions = await getSearchOptions());
	});

	/**
 * 検索パラメータを送信して検索結果を更新する
 *
 * @param  object e イベントハンドラ
 * @return void
 */
	async function sendOptions(e) {
		set_store_value(isLoading, $isLoading = true, $isLoading);

		if (e && '検索' === e.target.value) {
			set_store_value(inputValues, $inputValues['pid'] = '1', $inputValues);
		}

		set_store_value(searchResult, $searchResult = {}, $searchResult);
		set_store_value(searchResult, $searchResult = await getSearchResult($inputValues), $searchResult);
		await setCurrentParams($inputValues);

		//setURLParams($currentParams);
		set_store_value(isLoading, $isLoading = false, $isLoading);
	}

	const backgroundStyle = 'background: url(' + __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL + '/img/lithos_philia/common/bg_litsearchbox.webp) 0 0 repeat;';
	return [inputOptions, $isLoading, sendOptions, backgroundStyle];
}

class SearchControlPanel extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default SearchControlPanel;